import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import moment from "moment";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import { getAbsentAlert, assignAbsentBudge, downloadStudentsCSV } from "@/services/common";
import RowItem from "../RowItem";
import { iconColor } from "@/consts/iconColor";
export default {
  name: "AttendanceClassroom",
  components: {
    RowItem: RowItem
  },
  data: function data() {
    return {
      date: "",
      days: moment().daysInMonth(),
      students: [],
      checkedClassrooms: [],
      byClassrooms: [],
      isLoading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["classrooms", "grades", "studentAddress"])), {}, {
    formattedDate: function formattedDate() {
      return moment(this.date).format("YYYY年MM月DD日(ddd)");
    }
  }),
  created: function created() {
    var ids = this.$route.query.id;

    if (ids) {
      //前のページからrouterで遷移してきた場合と、画面再読込の場合でパラメータの解釈が変わる
      if (!Array.isArray(this.$route.query.id)) {
        ids = [this.$route.query.id];
      }

      this.checkedClassrooms = ids;
    }

    this.date = this.$route.query.date ? this.$route.query.date : moment().format("YYYY-MM-DD");
    this.setData();
  },
  methods: {
    iconColor: iconColor,
    downloadStudentsCSV: downloadStudentsCSV,
    setData: function setData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var query, a, absentList3, absentList20, absentList30, d;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                query = "date=" + _this.date;

                _this.checkedClassrooms.forEach(function (v) {
                  return query += "&classrooms[]=" + v;
                });

                _context.next = 5;
                return getAbsentAlert();

              case 5:
                a = _context.sent;
                absentList3 = a.absentList3;
                absentList20 = a.absentList20;
                absentList30 = a.absentList30;
                _context.next = 11;
                return getData("reader/get_classroom_students_with_attendance?" + query);

              case 11:
                d = _context.sent;
                _this.byClassrooms = d.items.map(function (v) {
                  v.students.forEach(function (student, i) {
                    if (student.attendance[0]) {
                      student.attendanceType = student.attendance[0].type;
                    } else {
                      student.attendanceType = "";
                    }

                    student.absents = assignAbsentBudge(student, absentList3, absentList20, absentList30);
                    v.students[i] = student;
                  });
                  return v;
                });
                _this.isLoading = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getAttendanceClass: function getAttendanceClass(current, attendances) {
      var index = attendances.findIndex(function (_ref) {
        var date = _ref.date;
        return current.isSame(moment(date));
      });

      if (index > -1) {
        if (attendances[index].type.indexOf("欠席") > -1) {
          return "type_absence";
        }

        if (attendances[index].type.indexOf("早退") > -1) {
          return "type_early";
        }

        if (attendances[index].type.indexOf("遅刻") > -1) {
          return "type_late";
        }
      }
    }
  }
};